import './DebugIndicator.scss';
import { h } from 'vue';

export default function DebugIndicator(props: {
    should_show: boolean;
    text: string;
}) {
    return h('div', {
        class: {
            'debug-indicator': true,
            hidden: !props.should_show,
        }
    }, props.text);
}
